import axios from 'axios';

const createAutomation = () => {
    return axios.get('/automations/new');
};

const deleteAutomation = (id) => {
    return axios.delete(`/automations/flows/${id}`);
};

const disableAutomation = (id) => {
    return axios.patch(`/automations/flows/${id}/disable`);
};

const duplicateAutomation = (id) => {
    return axios.post(`/automations/flows/${id}/duplicate`);
};

const enableAutomation = (id) => {
    return axios.patch(`/automations/flows/${id}/enable`);
};

const getAutomations = () => {
    return axios.get('/automations/flows');
};

const getAutomationsTemplates = () => {
    return axios.get('/automations/flow-templates');
};

const useAutomationTemplate = (id) => {
    return axios.post(`/automations/flow-templates/${id}/use`);
};

export {
    createAutomation,
    deleteAutomation,
    disableAutomation,
    duplicateAutomation,
    enableAutomation,
    getAutomations,
    getAutomationsTemplates,
    useAutomationTemplate,
};
